import styled from 'styled-components';
import { colorWarning } from '@atlas-frontend/design-tokens';

export const TextWarning = styled.span`
  color: ${colorWarning};
`;
